module.exports = __webpack_public_path__ + "img/bespoke123_23.171ad23d.jpg";